import React from 'react'

export const  Header = () => {
  return (
    <div>
        <h1 className='bg-bgDark text-white text-center text-3xl font-bold p-5' >Top Courses</h1>
    </div>
  )
}